/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class FaultApi {
    static getInstance() {
        if (!this.instance) this.instance = new FaultApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取故障列表
    async getFaultList (num,size,chip_id){
        let url = `/api/v1/fault/page?page_num=${num}&page_size=${size}&chip_id=${chip_id}`
        let result = await this.getData(url,{},'GET')
        return result
    }


}

export {
    FaultApi
}